import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { MediaPermissionsService } from 'media/services/mediaPermissions.service'
import { MediaScannerService } from 'media/services/mediaScanner.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { BaseOperation } from './base'
import { MediaRenamingService } from 'media/services/mediaRenaming.service'

@Injectable({ providedIn: 'root' })
class RenameOp extends BaseOperation {
  icon = 'far fa-pencil'
  showInContextMenu = true
  showInAssetView = true
  supportsDirs = true
  supportsBundles = true
  triggersReload = true
  weight = 0

  constructor (
    private translate: TranslateService,
    private mediaPermissions: MediaPermissionsService,
    private mediaScanner: MediaScannerService,
    private mediaRenaming: MediaRenamingService,
  ) {
    super()
    this.label = translate.instant('Rename')
  }

  isVisibleForDir (dir) {
    return this.mediaPermissions.getPermissionForFile(dir)?.allowWriteFs ?? false
  }

  isEnabledForDir (dir) {
    return dir.present
  }

  isVisibleForBundle (bundle) {
    return this.mediaPermissions.getPermissionForBundle(bundle)?.allowWriteFs ?? false
  }

  isEnabledForBundle (bundle) {
    return bundle.mainfile?.present && this.mediaScanner.assetBeingScanned !== bundle.asset?.id
  }

  async runForDir (dir, context) {
    await this.mediaRenaming.renameFile(dir, context.root)
  }

  async runForBundle (bundle, context) {
    await this.mediaRenaming.renameBundle(bundle, context.root)
  }
}

MediaOperationsService.register(RenameOp)
